module.exports = __webpack_public_path__ + "img/xhs.3a81b9f9.png";